import { Controller } from "@hotwired/stimulus"

// A one-time notice: "Got it" remembers the dismissal in a cookie the server reads before it
// renders the notice again, then removes it from the page.
// Connects to data-controller="dismissible"
export default class extends Controller {
    static values = { cookie: String, value: String }

    dismiss(event) {
        event?.preventDefault()
        if (this.cookieValue) {
            const oneYear = 60 * 60 * 24 * 365
            document.cookie = `${this.cookieValue}=${encodeURIComponent(this.valueValue || "1")}; path=/; max-age=${oneYear}; samesite=lax`
        }
        this.element.remove()
    }
}
